// Escrita "offline-friendly" do Firestore.
//
// Com persistência ligada (ver core/firebase.js), o SDK aplica a escrita no
// cache local NA HORA, mas a Promise de setDoc/updateDoc/deleteDoc/commit só
// RESOLVE quando o servidor confirma. Offline (ou com internet ruim de
// viagem) isso nunca resolve até reconectar — e a UI, que dá `await` pra
// mostrar "salvo", fica pendurada.
//
// `commitWrite` desamarra isso: online, espera o ack do servidor (até um
// timeout de segurança) pra que erros reais (ex: permission-denied) ainda
// cheguem como rejeição. Se não houver ack a tempo (offline/sem internet),
// resolve como SUCESSO OTIMISTA — a escrita já está no cache e o SDK
// sincroniza sozinho ao reconectar.
//
// Uso: `await commitWrite(setDoc(ref, data));`  (passe a Promise da escrita)

const ONLINE_ACK_TIMEOUT_MS = 4000; // rede lenta ainda tenta confirmar
const OFFLINE_RESOLVE_MS = 200;     // offline: resolve quase na hora

export function commitWrite(writePromise) {
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  const timeoutMs = offline ? OFFLINE_RESOLVE_MS : ONLINE_ACK_TIMEOUT_MS;

  return new Promise((resolve, reject) => {
    let settled = false;

    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      // Sem confirmação a tempo → assume offline/sem internet. Sucesso
      // otimista; loga se a sincronização futura falhar de verdade.
      writePromise.catch((e) => console.warn('[firestore] sync pendente:', e?.message));
      resolve();
    }, timeoutMs);

    writePromise.then(
      (value) => { if (settled) return; settled = true; clearTimeout(timer); resolve(value); },
      (error) => { if (settled) return; settled = true; clearTimeout(timer); reject(error); },
    );
  });
}
